'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConditionSerializerService = function ConditionSerializerService(rsqlParserService, rsqlQueryService, strategyRecordService, RsqlQuery, StrategyCondition, StrategyConstants, momentService, urdConditionSerializerService, conditionsAndActionsService, bookingsIntakeSerializerService, conditionHelper, $log) {
  var type = StrategyConstants.CONDITION;
  var numberTypes = ['uint', '2uint', 'int', '2int', 'float', '2float', 'ufloat', '2ufloat', 'percent', '2percent'];
  var OPERATOR_AND = 'and';
  var OPERATOR_OR = 'or';
  var OPERATOR_BETWEEN = 'Between';
  var OPERATOR_NOT_BETWEEN = 'Not Between';
  var DEPT_DATE_DOW = '.departureDateDOW';
  function provideRsqlQuery() {
    return new RsqlQuery().withOrOperator(' or ');
  }
  function serialize(level, entityType, flowType, strategyConditions, withoutFlowTypeAndUrdAppend) {
    withoutFlowTypeAndUrdAppend = withoutFlowTypeAndUrdAppend || false;
    var conditionsGroups = getConditionsGroups(strategyConditions);
    var queryBuilder = _.reduce(conditionsGroups, function (queryBuilder, group) {
      var groupQuery = provideRsqlQuery();
      var orRulesLength = group.orRules.length;
      var andRulesLength = group.andRules.length;
      if (orRulesLength >= 1) {
        groupQuery = addRsqlQueryGroup(group.orRules, groupQuery, OPERATOR_OR, level, entityType, flowType);
      }
      if (andRulesLength >= 1) {
        groupQuery = addRsqlQueryGroup(group.andRules, groupQuery, OPERATOR_AND, level, entityType, flowType);
      }
      if (groupQuery.queue === undefined) {
        return queryBuilder;
      }
      var and = queryBuilder.and();
      return orRulesLength + andRulesLength >= 1 ? and.andGroupSimple.apply(and, [groupQuery]) : and;
    }, provideRsqlQuery().and());
    if (!withoutFlowTypeAndUrdAppend) {
      appendFlowTypeCondition(queryBuilder, level, flowType);
      appendUrdProfileExistenceCheck(queryBuilder, level, strategyConditions, flowType, entityType);
    }
    return queryBuilder.query();
  }
  function appendFlowTypeCondition(queryBuilder, domain, flowType) {
    var level = conditionsAndActionsService.getLevelByDomain(domain);
    if (level && level.flowTypeField && flowType !== 'FlowType.BOTH') {
      var flowTypeQuery = buildFlowTypeRule(provideRsqlQuery(), level.flowTypeField, flowType);
      if (!flowTypeQuery.isEmpty()) {
        queryBuilder.and().andGroupSimple(flowTypeQuery);
      }
    }
  }

  // only for these levels FlowType (Regular/Mapped) makes sense
  function isFlowTypeDependentLevel(level) {
    return level === 'MarketDemandPOS' || level === 'MarketDemandClassGroup' || level === 'ServiceClassPOS';
  }

  /**
   * If URD conditions present - appends query verifying that profile exists at the end of all conditions
   * Example: ";marketDemandClassGroup.urd('REGULAR_DEMAND','AVG','14')!=null;"
   * will be attached if specified condition is "marketDemandClassGroup.demand.remainingDemandFC=le=marketDemandClassGroup.urd('REGULAR_DEMAND','AVG','14')"
   */
  function appendUrdProfileExistenceCheck(queryBuilder, level, strategyConditions, flowType, entityType) {
    flowType = isFlowTypeDependentLevel(level) && flowType !== 'FlowType.BOTH' ? flowType : null;

    //filter out URD conditions
    _.chain(strategyConditions).filter(function (cond) {
      return cond.appendices && cond.appendices.urdFunctionType;
    }).forEach(function (condition) {
      var fieldType = strategyRecordService.getValueType(type, level, entityType, condition.category, condition.criterion, condition.operator);
      var leftOperand = urdConditionSerializerService.isUrdCategory(condition.category) ? urdConditionSerializerService.serialize(condition.field, condition.leftOperand, condition.criterion, condition.appendices.urdFunctionType, flowType) : rsqlQueryService.formatOperand(condition.leftOperand, fieldType);
      var urdProfileExistsQuery = buildURDProfileExistsRule(provideRsqlQuery(), leftOperand);
      if (!urdProfileExistsQuery.isEmpty()) {
        queryBuilder.and().andGroupSimple(urdProfileExistsQuery);
      }
    }).value();
  }
  function buildFlowTypeRule(builder, flowTypeField, flowType) {
    var value = flowType || flowTypeField.defaultValue;
    builder = builder.is(flowTypeField.name);
    builder = builder[rsqlQueryService.getRsqlOperator(flowTypeField.operator, value)].call(builder, value);
    return builder;
  }

  /**
   * Appends query verifying that profile exists
   * Example: marketDemandClassGroup.urd('REGULAR_DEMAND','AVG','14')!=null;
   */
  function buildURDProfileExistsRule(builder, leftOperand) {
    var method = rsqlQueryService.getRsqlOperator('!='),
      value = null;
    builder = builder.is(leftOperand);
    builder = builder[method].call(builder, value);
    return builder;
  }
  function createRsqlQueryGroup(rules, level, entityType, operatorType, flowType) {
    var rsqlQuery = provideRsqlQuery();
    return _.chain(rules).transform(createRsqlQuery(level, entityType, flowType)).reduce(function (query, rule) {
      if (rule.isEmpty()) {
        return query;
      } else if (operatorType === OPERATOR_AND) {
        return query.and().andGroupSimple(rule);
      } else {
        return query.or().orGroupSimple(rule);
      }
    }, rsqlQuery).thru(function (query) {
      return query.isEmpty() ? [] : [query];
    }).value();
  }
  function parseFieldValue(value) {
    return !_.isNaN(parseFloat(value)) ? parseFloat(value) : null;
  }
  function createRsqlQuery(level, entityType, flowType) {
    flowType = isFlowTypeDependentLevel(level) && flowType !== '' ? flowType : null;
    return function (result, condition) {
      var builder = provideRsqlQuery();
      var fieldType = strategyRecordService.getValueType(type, level, entityType, condition.category, condition.criterion, condition.operator);
      if (numberTypes.indexOf(fieldType) !== -1) {
        condition.leftOperand = parseFieldValue(condition.leftOperand);
        condition.rightOperand = condition.rightOperand ? parseFieldValue(condition.rightOperand) : condition.rightOperand;
      }
      var method = rsqlQueryService.getRsqlOperator(condition.operator, condition.leftOperand, condition.rightOperand || condition.leftOperand);
      if (conditionHelper.isSingleToMultiValueMapped(condition)) {
        condition.leftOperand = [condition.leftOperand];
      }
      var formattedLeftOperand = urdConditionSerializerService.isUrdCategory(condition.category) ? urdConditionSerializerService.serialize(condition.field, condition.leftOperand, condition.criterion, condition.appendices.urdFunctionType, flowType) : rsqlQueryService.formatOperand(condition.leftOperand, fieldType);
      var formattedRightOperand = urdConditionSerializerService.isUrdCategory(condition.category) ? urdConditionSerializerService.serialize(condition.field, condition.rightOperand, condition.criterion, condition.appendices.urdFunctionType, flowType) : rsqlQueryService.formatOperand(condition.rightOperand, fieldType);
      var conditionsOperand = bookingsIntakeSerializerService.isBookingsIntakeCriterion(condition.criterion) ? bookingsIntakeSerializerService.serialize(condition.field, condition.appendices.daysOffsets) : bookingsIntakeSerializerService.isBookingsIntakePercentCriterion(condition.criterion) ? bookingsIntakeSerializerService.serializePercent(condition.field, condition.appendices.daysOffsetsInPercent) : null;
      if (OPERATOR_BETWEEN === condition.operator) {
        method = 'between';
      } else if (OPERATOR_NOT_BETWEEN === condition.operator) {
        method = 'notBetween';
      }
      var conditionField = conditionsOperand === null ? condition.field : conditionsOperand;
      builder = builder.is(conditionField, [OPERATOR_BETWEEN, OPERATOR_NOT_BETWEEN].indexOf(condition.operator) > -1);
      builder = builder[method].call(builder, formattedLeftOperand, formattedRightOperand);
      return result.push(builder);
    };
  }
  function addRsqlQueryGroup(rules, builder, operatorType, level, entityType, flowType) {
    var queryGroup = createRsqlQueryGroup(rules, level, entityType, operatorType, flowType);
    if (queryGroup.length === 0) {
      return builder;
    }
    builder = builder.and();
    if (operatorType === OPERATOR_AND) {
      builder = builder.andGroupSimple.apply(builder, queryGroup);
    } else if (operatorType === OPERATOR_OR) {
      builder = builder.orGroupSimple.apply(builder, queryGroup);
    }
    return builder;
  }
  function isRuleOperatorConvertibleToInclusionType(rule) {
    return rule.operator !== OPERATOR_BETWEEN && rsqlQueryService.isInclusionTypeOperator(rule.operator);
  }
  function isRuleOperatorConvertibleToExclusionType(rule) {
    return rule.operator === OPERATOR_BETWEEN || rsqlQueryService.isExclusionTypeOperator(rule.operator);
  }
  function getOrConnectedRules(rules) {
    return _.filter(rules, isRuleOperatorConvertibleToInclusionType);
  }
  function getAndConnectedRules(rules) {
    return _.filter(rules, isRuleOperatorConvertibleToExclusionType);
  }
  function getConditionsGroups(rules) {
    return _.chain(rules).groupBy(function (rule) {
      if (rule.category === 'CLOSURE_GROUP_DTD' || rule.category === 'CLOSURE_GROUP_LOAD') {
        return 'CLOSURE_GROUP_DTD_LOAD';
      }
      return (rule.metaCategory || rule.category) + '-' + rule.field.split('.')[0];
    }).transform(function (result, rules, metaCategory) {
      result[metaCategory] = {
        orRules: getOrConnectedRules(rules),
        andRules: getAndConnectedRules(rules)
      };
      return result;
    }, {}).value();
  }
  function isComboboxObject(val) {
    return _.isObject(val) && _.has(val, 'value');
  }
  function transformOperand(type, availableValues, value) {
    if (value) {
      switch (type) {
        case 'int':
          return _.isString(value) ? parseInt(value, 10) : value;
        case 'float':
          return _.isString(value) ? parseFloat(value, 10) : value;
        case '2localdate':
        case 'localdate':
          return momentService.of(value, momentService.FIELD.RULE_CRITERIA_DATE);
        case '2time':
        case 'time':
          return momentService.of(value, momentService.FIELD.RULE_CRITERIA_TIME, momentService.FORMAT.TIME_ISO);
        case 'combo':
          if (availableValues && availableValues.length > 0 && isComboboxObject(availableValues[0])) {
            return _.find(availableValues, ['value', value]);
          }
          return value;
        case '2combo':
          return {
            value: value,
            dropdownVisibleValue: value
          };
      }
    }
    return value;
  }
  function getOperand(args, isMulti, type) {
    switch (type) {
      case 'left':
        return isMulti ? args : args[0];
      case 'right':
        return isMulti ? undefined : args[1];
    }
  }
  function createStrategyConditions(level, entityType, flowType, condition, quantifier) {
    if (condition !== '') {
      if (condition.children) {
        return _.reduce(condition.children, function (result, child, index) {
          var newQuantifier = index === 0 ? quantifier : condition.operator;
          var items = createStrategyConditions(level, entityType, flowType, child, newQuantifier);
          Array.prototype.push.apply(result, items);
          return result;
        }, []);
      }
      var isUrdConditionByOperandValue = urdConditionSerializerService.isUrdConditionByOperandValue(getOperand(condition.arguments, false, 'left'));
      var isBookingsIntakeCondition = bookingsIntakeSerializerService.isBookingsIntakeByOperandValue(getOperand(condition.selector.split(','), false, 'left'));
      var isBookingsIntakePercentCondition = bookingsIntakeSerializerService.isBookingsIntakePercentByOperandValue(getOperand(condition.selector.split(','), false, 'left'));
      var isDOWCriteriaCondition = isDOWCriteria(getOperand(condition.selector.split(','), false, 'left'));
      var possibleFields = strategyRecordService.getCategoryCriteriaForField(type, level, entityType, flowType, condition.selector);
      var fieldData = _.find(possibleFields, function (element) {
        var returnValue = isUrdConditionByOperandValue ? element.category === urdConditionSerializerService.URD_CATEGORY : element.category !== urdConditionSerializerService.URD_CATEGORY;
        returnValue = isBookingsIntakeCondition ? element.criteria === bookingsIntakeSerializerService.BOOKINGS_INTAKE : returnValue;
        returnValue = isBookingsIntakePercentCondition ? element.criteria === bookingsIntakeSerializerService.BOOKINGS_INTAKE_PERCENT : returnValue;
        return returnValue;
      });
      var operator = isDOWCriteriaCondition ? rsqlQueryService.operatorToDOWUiValue(condition.operator) : rsqlQueryService.operatorToUiValue(condition.operator);
      var fieldType = strategyRecordService.getValueType(type, level, entityType, fieldData.category, fieldData.criteria, operator);
      var availableValues = strategyRecordService.getAvailableValues(type, level, entityType, fieldData.category, fieldData.criteria, operator);
      var precision = strategyRecordService.getPrecision(type, level, entityType, fieldData.category, fieldData.criteria, operator);
      var isFieldValueRequired = strategyRecordService.getIsFieldValueRequired(type, level, entityType, fieldData.category);
      var isMulti = fieldType === 'multi' || fieldType === 'dow';
      var deserializedUrdValue;
      var deserializedDaysOffsetsValue;
      var deserializedDaysOffsetsInPercentValue;
      if (isUrdConditionByOperandValue) {
        deserializedUrdValue = urdConditionSerializerService.deserialize(getOperand(condition.arguments, isMulti, 'left'));
      } else if (isBookingsIntakeCondition) {
        deserializedDaysOffsetsValue = bookingsIntakeSerializerService.deserialize(condition);
      } else if (isBookingsIntakePercentCondition) {
        deserializedDaysOffsetsInPercentValue = bookingsIntakeSerializerService.deserialize(condition);
      }
      var leftOperand = isUrdConditionByOperandValue ? deserializedUrdValue.leftOperand : getOperand(condition.arguments, isMulti, 'left');
      leftOperand = isBookingsIntakeCondition && deserializedDaysOffsetsValue ? deserializedDaysOffsetsValue.leftOperand : leftOperand;
      leftOperand = isBookingsIntakePercentCondition && deserializedDaysOffsetsInPercentValue ? deserializedDaysOffsetsInPercentValue.leftOperand : leftOperand;
      var rightOperand = getOperand(condition.arguments, isMulti, 'right');
      var appendices = deserializedUrdValue && {
        urdFunctionType: deserializedUrdValue.functionType
      };
      appendices = isBookingsIntakeCondition ? deserializedDaysOffsetsValue && {
        daysOffsets: deserializedDaysOffsetsValue.functionType
      } : appendices;
      appendices = isBookingsIntakePercentCondition ? deserializedDaysOffsetsInPercentValue && {
        daysOffsetsInPercent: deserializedDaysOffsetsInPercentValue.functionType
      } : appendices;
      return [new StrategyCondition({
        category: fieldData.category,
        metaCategory: fieldData.metaCategory,
        criterion: fieldData.criteria,
        field: condition.selector,
        fieldType: fieldType,
        operator: operator,
        leftOperand: transformOperand(fieldType, availableValues, leftOperand),
        rightOperand: transformOperand(fieldType, availableValues, rightOperand),
        quantifier: quantifier && quantifier.toUpperCase(),
        precision: precision,
        appendices: appendices,
        isFieldValueRequired: isFieldValueRequired
      })];
    }
  }
  function parse(input) {
    return rsqlParserService.parse(input);
  }
  function isDOWCriteria(input) {
    return _.isString(input) && input.indexOf(DEPT_DATE_DOW) !== -1;
  }
  function isFlowTypeCondition(condition) {
    return !!condition.match(new RegExp(StrategyConstants.FlowType.join('|'), 'g'));
  }
  function isURDProfileExistsCondition(condition) {
    return !!condition.match(/\.urd/) && !!condition.match('!=null');
  }
  function deserialize(level, entityType, flowType, input) {
    var conditionGroups = input.split(';');
    _.remove(conditionGroups, isFlowTypeCondition);
    _.remove(conditionGroups, isURDProfileExistsCondition);
    input = conditionGroups.join(';');
    input = unescapeConditionsInsideOperandValue(input);
    try {
      input = input !== '' ? parse(input) : input;
    } catch (e) {
      deserializeErrorHandler(input);
      return;
    }
    return createStrategyConditions(level, entityType, flowType, input);
  }
  function deserializeErrorHandler(input) {
    var message = 'Couldn\'t parse condition: ' + input;
    $log.error('ConditionSerializerService: deserializeErrorHandler - ' + message);
    toastr.error(message);
  }
  function unescapeConditionsInsideOperandValue(operand) {
    var unescapedOperand = operand.replace(' %and% ', ' and ');
    unescapedOperand = unescapedOperand.replace(' %or% ', ' or ');
    return unescapedOperand;
  }
  return {
    parse: parse,
    serialize: serialize,
    deserialize: deserialize
  };
};
ConditionSerializerService.$inject = ['RsqlParserService', 'RsqlQueryService', 'StrategyRecordService', 'RsqlQueryFactory', 'StrategyConditionFactory', 'StrategyConstants', 'MomentService', 'UrdConditionSerializerService', 'ConditionsAndActionsService', 'BookingsIntakeSerializerService', 'ConditionHelper', '$log'];
module.exports = ConditionSerializerService;